<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base hidden">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2" disabled>Upload photo</vs-button>
        <vs-button type="border" color="danger" disabled>Remove</vs-button>
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
      </div>
    </div>

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="First Name" v-model="current_user.first_name"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Last Name" v-model="current_user.last_name"></vs-input>
    <vs-input class="w-full" label-placeholder="Email" v-model="current_user.email"></vs-input>
    <vs-input class="w-full" label-placeholder="Phone" v-model="current_user.main_telephone"></vs-input>

    <vs-alert v-if="current_user.is_active === 0" icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
      <span>Your account is not verified. <a href="#" class="hover:underline">Resend Confirmation</a></span>
    </vs-alert>
    <vs-alert v-else icon-pack="feather" icon="icon-info" class="h-full my-4" color="success">
      <span>Your account is verified.</span>
    </vs-alert>

    <!-- <vs-textarea class="w-full my-base" label-placeholder="Address" v-model="current_user.address_1"></vs-textarea> -->

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end hidden">
      <vs-button disabled class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" disabled>Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import profile from '@/apis/profile.js'


export default {
  data () {
    return {
      username: 'Janaka Edirisinghe',
      name: this.$store.state.AppActiveUser.displayName,
      email: 'janaka@10qbit.com',
      company: '10Qbit Pvt Ltd',
      current_user: {}
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  async mounted() {
    this.$vs.loading()
    const {data} =  await profile.getCurrentUser()
    this.current_user = data.data
    this.$vs.loading.close()
  }
}
</script>
